const DecreaseTriangle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
    >
      <path
        d="M3.52979 5.26676C3.76733 5.57775 4.23267 5.57775 4.47021 5.26676L7.37572 1.46284C7.6761 1.06959 7.39793 0.5 6.90551 0.5H1.09449C0.602065 0.5 0.323904 1.06959 0.624278 1.46284L3.52979 5.26676Z"
        fill="#3BA3C7"
      />
    </svg>
  );
};

export default DecreaseTriangle;
